module.exports = __webpack_public_path__ + "static/img/2257_phase_function_Paper_PointsHejduk_Prediction.dede465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2257_phase_function_Paper_PointsHejduk_Prediction.png
// module id = yjM/
// module chunks = 0